import Model, { attr, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum InboxMessageChannel {
  airbnb = 'airbnb',
  bookingDotCom = 'booking_dot_com',
  google = 'google',
  homeAway = 'home_away',
  uplisting = 'uplisting',
}

export interface IAssignableUser {
  id: string;
  name: string;
}

export default class InboxMessageModel extends Model {
  @attr('string') externalId!: string;
  @attr('string') content!: string;
  @attr('string') channel!: InboxMessageChannel;
  @attr('boolean') inbound!: boolean;
  @attr('string') from!: string;
  @attr('boolean') unread!: boolean;
  @attr('boolean') starred!: boolean;
  @attr('boolean') archived!: boolean;
  @attr('string') status!: string;
  @attr('date') lastMessageAt!: Date;
  @attr('string') lastMessageType!: string;
  @attr('number') lastMessageId!: number;
  @attr('string') propertyName!: string;
  @attr('string') guestName!: string;
  @attr('string') guestProfilePicture!: string;
  @attr('string') assignedUserId!: string | null;
  @attr('string') assignedUserName!: string | null;
  @attr('array') assignableUsers!: IAssignableUser[];

  @hasMany('booking', { async: false, inverse: 'inboxMessage' })
  bookings!: ModelRegistry['booking'][];

  @hasMany('booking-request', { async: false, inverse: 'inboxMessage' })
  bookingRequests!: ModelRegistry['booking-request'][];

  @hasMany('enquiry', { async: false, inverse: 'inboxMessage' })
  enquiries!: ModelRegistry['enquiry'][];

  @cached
  get isAirbnb(): boolean {
    return this.channel === InboxMessageChannel.airbnb;
  }

  @cached
  get isBookingDotCom(): boolean {
    return this.channel === InboxMessageChannel.bookingDotCom;
  }

  @cached
  get isGoogle(): boolean {
    return this.channel === InboxMessageChannel.google;
  }

  @cached
  get isHomeAway(): boolean {
    return this.channel === InboxMessageChannel.homeAway;
  }

  @cached
  get isUplisting(): boolean {
    return this.channel === InboxMessageChannel.uplisting;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'inbox-message': InboxMessageModel;
  }
}
